import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { updateProfile } from "../../../../../redux/profile/action";
import { useDispatch } from "react-redux";
import { postTeam } from "../../../../../redux/team/action";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import { titlevalidation } from "../../../../Common/commonvalidation";

export default function TeamsProjectModel({ setProjectmodel }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState("");
  const dispatch = useDispatch();
  const initialValues = {
    title: formData?.expert?.title || "",
  };

  const validationSchema = Yup.object().shape({
    title: titlevalidation,
  });

  const handleSubmit = (values) => {
    setLoading(true);

    const data = {
      ...values,
      type: 1,
    };
    dispatch(postTeam(data));
    setProjectmodel((state) => !state);
    setLoading(true);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {() => (
        <>
          <a
            onClick={() => setProjectmodel((state) => !state)}
            className="btn close-button"
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
              alt=""
            />
          </a>
          <Form>
            <ModalBody>
              <h4>Create A Project</h4>

              <div className="form-group">
                <label className="label-s">Project Title</label>
                <Field
                  className="form-control input"
                  type="text"
                  name="title"
                  placeholder="Your title"
                />
                <ErrorMessage name="title" component="div" className="error" />
              </div>
            </ModalBody>
            <div className="modal-footer mt-3">
              <button className="btn " type="submit" disabled={loading}>
                {loading ? <LoginLoaderButton /> : "Save"}
              </button>
            </div>
          </Form>
        </>
      )}
    </Formik>
  );
}
